module.exports = __webpack_public_path__ + "static/img/TV.a871f034.png";